import type { ComponentProps } from "react";
import type ReactSignatureCanvasType from "react-signature-canvas";
import SignatureCanvasModule from "react-signature-canvas";
import { unwrapModuleDefault } from "./internal/interop";

const SignatureCanvas = unwrapModuleDefault<typeof ReactSignatureCanvasType>(SignatureCanvasModule);

export type SignatureCanvasProps = ComponentProps<typeof ReactSignatureCanvasType>;
export type SignatureCanvasRef = InstanceType<typeof ReactSignatureCanvasType>;

export default SignatureCanvas;
